module.exports = {
  CYAN_USER: 1,
  DARK_BLUE_USER: 2,
  PURPLE_USER: 3,
  GREEN_USER: 4,
  GRAY_USER: 5,
  ORANGE_USER: 6,
  YELLOW_USER: 7
}